var map = {
	"./Account": [
		1826,
		918
	],
	"./Account.vue": [
		1826,
		918
	],
	"./Asset": [
		52,
		497
	],
	"./Asset.vue": [
		52,
		497
	],
	"./Client": [
		8893,
		896
	],
	"./Client.vue": [
		8893,
		896
	],
	"./Crypto/Account": [
		6019,
		661
	],
	"./Crypto/Account.vue": [
		6019,
		661
	],
	"./Crypto/Index": [
		2956,
		577
	],
	"./Crypto/Index.vue": [
		2956,
		577
	],
	"./Crypto/Report": [
		9277,
		284
	],
	"./Crypto/Report.vue": [
		9277,
		284
	],
	"./Crypto/Trade": [
		3687,
		997
	],
	"./Crypto/Trade.vue": [
		3687,
		997
	],
	"./Crypto/Transaction": [
		215,
		491
	],
	"./Crypto/Transaction.vue": [
		215,
		491
	],
	"./Datasource/Index": [
		192,
		703
	],
	"./Datasource/Index.vue": [
		192,
		703
	],
	"./Datasource/Record": [
		3840,
		743
	],
	"./Datasource/Record.vue": [
		3840,
		743
	],
	"./Datasource/Template": [
		5756,
		140
	],
	"./Datasource/Template.vue": [
		5756,
		140
	],
	"./Datasource/UploadFile": [
		899,
		264
	],
	"./Datasource/UploadFile.vue": [
		899,
		264
	],
	"./Document/Index": [
		1611,
		273
	],
	"./Document/Index.vue": [
		1611,
		273
	],
	"./Document/Record": [
		6952,
		973
	],
	"./Document/Record.vue": [
		6952,
		973
	],
	"./Document/Template": [
		9754,
		554
	],
	"./Document/Template.vue": [
		9754,
		554
	],
	"./Index": [
		3426,
		726
	],
	"./Index.vue": [
		3426,
		726
	],
	"./Login": [
		361,
		438
	],
	"./Login.vue": [
		361,
		438
	],
	"./RealEstate/Index": [
		6318,
		589
	],
	"./RealEstate/Index.vue": [
		6318,
		589
	],
	"./RealEstate/Location": [
		2357,
		363
	],
	"./RealEstate/Location.vue": [
		2357,
		363
	],
	"./RealEstate/Property": [
		5913,
		411
	],
	"./RealEstate/Property.vue": [
		5913,
		411
	],
	"./RealEstate/Receivable": [
		1762,
		595
	],
	"./RealEstate/Receivable.vue": [
		1762,
		595
	],
	"./RealEstate/Rental": [
		5515,
		931
	],
	"./RealEstate/Rental.vue": [
		5515,
		931
	],
	"./RealEstate/Tenant": [
		4198,
		107
	],
	"./RealEstate/Tenant.vue": [
		4198,
		107
	],
	"./Report": [
		7693,
		392
	],
	"./Report.vue": [
		7693,
		392
	],
	"./ResetPassword": [
		6904,
		547
	],
	"./ResetPassword.vue": [
		6904,
		547
	],
	"./Setting/Asset": [
		277,
		872
	],
	"./Setting/Asset.vue": [
		277,
		872
	],
	"./Setting/Backup": [
		6321,
		624
	],
	"./Setting/Backup.vue": [
		6321,
		624
	],
	"./Setting/Category": [
		9984,
		868
	],
	"./Setting/Category.vue": [
		9984,
		868
	],
	"./Setting/ClosingPrice": [
		1203,
		215
	],
	"./Setting/ClosingPrice.vue": [
		1203,
		215
	],
	"./Setting/Index": [
		3819,
		955
	],
	"./Setting/Index.vue": [
		3819,
		955
	],
	"./Setting/Market": [
		7520,
		219
	],
	"./Setting/Market.vue": [
		7520,
		219
	],
	"./Setting/Report": [
		5972,
		398
	],
	"./Setting/Report.vue": [
		5972,
		398
	],
	"./Setting/Trade": [
		229,
		852
	],
	"./Setting/Trade.vue": [
		229,
		852
	],
	"./Trade": [
		610,
		683
	],
	"./Trade.vue": [
		610,
		683
	],
	"./Transaction": [
		6282,
		330
	],
	"./Transaction.vue": [
		6282,
		330
	],
	"./User/Index": [
		7246,
		123
	],
	"./User/Index.vue": [
		7246,
		123
	],
	"./User/Permission": [
		1390,
		923
	],
	"./User/Permission.vue": [
		1390,
		923
	],
	"./User/User": [
		8756,
		36
	],
	"./User/User.vue": [
		8756,
		36
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8099;
module.exports = webpackAsyncContext;